import React from 'react'

import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import GeneralRequirements from '../components/Requirements_General'
import WindowsRequirements from '../components/Requirements_Windows'
import MacRequirements from '../components/Requirements_Mac'
import TabletRequirements from '../components/Requirements_Tablets'


const RequirementsTabs = (props) => {
    const NoSupport = Brightness(props.themeStyles.background, 1);
    const HoverLink = Brightness(props.themeStyles.mainColor, -0.4);

    const TabStyles = styled.div`

      a {
        color: ${HoverLink};
        font-weight: 500;
        text-decoration: underline;

        &:hover {
          color: ${props.themeStyles.mainColor};
        }
      }

      .osDetails {
        color: ${props.themeStyles.fontColor};
      }

      .supportTable {
        .row {
          border-bottom: solid 1px ${props.themeStyles.fontColor};
        }
      }

      .column {
        .noSupport {
          background-color: ${NoSupport}
        }
      }
    `

    const osReqs = props.osReqs

    const reqPicker = (a) => {
      switch (a) {
        case 'windows':
          return <WindowsRequirements />
          break;

          case 'mac':
            return <MacRequirements />
            break;

            case 'tablets':
              return <TabletRequirements />
              break;

        default:
          return <GeneralRequirements />
      }
    }

    return (

      <TabStyles id="tabContainer">

        {reqPicker(osReqs)}

      </TabStyles>

    )


}

export default RequirementsTabs
